<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
    <vs-sidebar-group title="Sensor Tracking" open>
      <vs-sidebar-item :to="'IndoorDashboard'" index="3" icon="dashboard">
        Dashboard
      </vs-sidebar-item>
      <vs-sidebar-item :to="'IndoorOverview'" index="1" icon="cloud_queue">
        Overview
      </vs-sidebar-item>
      <vs-sidebar-item :to="'IndoorReport'" index="2" icon="description">
        Report
      </vs-sidebar-item>

      <vs-sidebar-group title="Device Mangement">
        <vs-sidebar-item :to="'IndoorSensor'" index="2.1" icon="contactless">
          Sensor
        </vs-sidebar-item>

        <vs-sidebar-item :to="'IndoorGateway'" index="2.3" icon="router">
          Gateway
        </vs-sidebar-item>
        <vs-sidebar-item :to="'IndoorAlert'" index="2.3" icon="report_problem">
          Alert
        </vs-sidebar-item>
      </vs-sidebar-group>

      <vs-sidebar-group title="Setting" v-if="admin == user">
        <vs-sidebar-item
          :to="'IndoorAlertSetting'"
          index="2.1"
          icon="new_releases"
        >
          Alert Setting
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/user'" index="2.3" icon="person">
          User
        </vs-sidebar-item>
      </vs-sidebar-group>
    </vs-sidebar-group>

    <footer-sidebar slot="footer"></footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data: () => ({
    user: "",
    admin: ""
  }),
  mounted() {
    this.user = this.$session.get("username")
    this.admin = this.$session.get("admin")
  }
};
</script>

<style>
</style>